import { mapState, mapActions } from 'vuex'

export default {
    
    computed: {

        stateSpent: {
            get () {
                if (this.single.spent_hours_minutes) {
                    return `${('00'+this.single.spent_hours_minutes.hours).slice(-2)}:${('00'+this.single.spent_hours_minutes.minutes).slice(-2)}`
                }

                return this.single.spent
            },

            set (value) {
                this.setSingleProperty({ property: 'spent', value })
            }
        },
        stateEntryDate: {
            get () {
                return this.single.entry_date
            },

            set (value) {
                this.setSingleProperty({ property: 'entry_date', value })
            }
        },
        stateReference: {
            get () {
                return this.single.reference
            },

            set (value) {
                this.setSingleProperty({ property: 'reference', value })
            }
        },
        stateUser: {
            get () {
                return this.single.user
            },

            set (value) {
                this.setSingleProperty({ property: 'user', value })
            }
        },
        stateUserId: {
            get () {
                return this.single.user_id
            },

            set (value) {
                this.setSingleProperty({ property: 'user_id', value })
            }
        },
        
        
    },
    methods: mapActions('yodizproject/effort', ['setSingleProperty'])
}
